import { css } from '@emotion/react';

export type AspectRatios = '1/1' | '2/1' | '16/9' | '3/2' | 'none';

export interface ImageProps {
  src: string;
  alt: string;
  className?: string;
  aspectRatio?: AspectRatios;
}

const imageCSS = (ratio?: string) => css`
  max-width: 100%;
  ${ratio
    ? `
    aspect-ratio: ${ratio};
    object-fit: cover;

  `
    : ''}
`;

export const Image = ({ src, alt, className, aspectRatio }: ImageProps) => {
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      css={imageCSS(aspectRatio)}
    />
  );
};
